import type { CustomerProfileCardGetModelDTO } from '@/types/dto/agent';

// `regionalCardTypeIds` lets the caller mark a type regional from master data
// too: profile cards can come back without the flag right after login, and a
// regional card must never be offered as removable.
export function partitionProfileCards(
  cards: CustomerProfileCardGetModelDTO[],
  regionalCardTypeIds: ReadonlySet<string> = new Set()
): {
  regional: CustomerProfileCardGetModelDTO[];
  selectable: CustomerProfileCardGetModelDTO[];
} {
  const isRegional = (card: CustomerProfileCardGetModelDTO) =>
    card.isRegionalReductionCard || regionalCardTypeIds.has(card.cardTypeId);

  const activeCards = cards.filter((card) => card.isActive);

  return {
    regional: activeCards.filter(isRegional),
    selectable: activeCards.filter((card) => !isRegional(card)),
  };
}
